// extracted by mini-css-extract-plugin
export default {"navWrapper":"EachVendorHeader_navWrapper__OQdbn","activeNavBtn":"EachVendorHeader_activeNavBtn__1Cc0G","defaultNavBtn":"EachVendorHeader_defaultNavBtn__qW-QA"};